package com.ervasstudio.tracoemovimento.components.custumcomponents

import androidx.compose.runtime.Composable
import com.ervasstudio.tracoemovimento.util.Res.Image.butaobg
import com.ervasstudio.tracoemovimento.util.Res.MyColors.Lilas
import com.varabyte.kobweb.compose.foundation.layout.Arrangement
import com.varabyte.kobweb.compose.foundation.layout.Box
import com.varabyte.kobweb.compose.foundation.layout.Row
import com.varabyte.kobweb.compose.ui.Alignment
import com.varabyte.kobweb.compose.ui.Modifier
import com.varabyte.kobweb.compose.ui.modifiers.color
import com.varabyte.kobweb.compose.ui.modifiers.fontFamily
import com.varabyte.kobweb.compose.ui.modifiers.fontSize
import com.varabyte.kobweb.compose.ui.modifiers.width
import com.varabyte.kobweb.silk.components.graphics.Image
import com.varabyte.kobweb.silk.components.text.SpanText
import org.jetbrains.compose.web.css.px

@Composable
fun BotaoEstilizado(nome: String, isMobile: Boolean = false) {
    Box(
        contentAlignment = Alignment.Center,
        modifier = Modifier
    ) {
        Image(src = butaobg, width = if (isMobile) 85 else 160)
        Row(
            modifier = Modifier.width(if (isMobile) 85.px else 160.px),
            horizontalArrangement = Arrangement.Center,
            verticalAlignment = Alignment.CenterVertically
        ) {
            SpanText(
                text = nome,
                modifier = Modifier.fontFamily("museomoderno").fontSize(if (isMobile) 10.px else 20.px)
                    .color(Lilas),
            )
        }
    }
}